import React from 'react';
import s from './SimpleeCreateDifference.module.css';
import IconX from '../../../shared/ui/icons/IconX';
import IconCheck from '../../../shared/ui/icons/IconCheck';
import IconCircleCross from '../../../shared/ui/icons/IconCircleCross';
import IconCircleCheck from '../../../shared/ui/icons/IconCircleCheck';
import {
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const SimpleeCreateDifference: React.FC = () => {
    const rows = [
        {
            left: 'Creates polished, sales-ready product visuals automatically — no prompts or design skills needed',
            right: 'Require endless tweaking, prompts, or manual editing to look professional',
        },
        {
            left: 'Understands your brand colors, tone, and layout — ensures consistency across every visual',
            right: 'Treat every image the same, producing generic results that don’t fit your brand',
        },
        {
            left: 'Designed for business owners and brands who want results, not just pretty visuals',
            right: 'Built for designers who have time to experiment and fine-tune every detail',
        },
    ];

    return (
        <section className={s.container}>
            <OptimizedMotionH2 type="slide-up" delay={0.3} className={s.title}>
                What makes <span className={s.highlight}>SimpleeCreate</span> different?
            </OptimizedMotionH2>

            <div className={s.table}>
                <div className={s.header}>
                    <div className={`${s.cell} ${s.leftHeader}`}>SimpleeCreate</div>
                    <div className={`${s.cell} ${s.rightHeader}`}>Other Tools</div>
                </div>

                {rows.map((row, i) => (
                    <div key={i} className={s.row}>
                        <div className={`${s.cell} ${s.left}`}>
                            <IconCircleCheck />
                            <OptimizedMotionP type="slide-up" delay={0.8} className={s.cellText}>
                                {row.left}
                            </OptimizedMotionP>
                        </div>
                        <div className={`${s.cell} ${s.right}`}>
                            <IconCircleCross />
                            <OptimizedMotionP type="slide-up" delay={0.8} className={s.cellText}>
                                {row.right}
                            </OptimizedMotionP>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default SimpleeCreateDifference;
